import { useState, useEffect } from 'react';
import axios from 'axios';
import { environment } from '../../../../environment/environment';

interface AuditTrailEntry {
  actioned_by_name: string;
  date: string;
  action: string;
  updated_fields: Array<{
    name: string;
    value?: string;
    old_value?: string;
    new_value?: string;
  }>;
}

export const useAuditTrail = (idNumber: string | null) => {
  const [data, setData] = useState<AuditTrailEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!idNumber) {
      setData([]);
      return;
    }

    const fetchAuditTrail = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.post(`${environment.baseUrl}/risky-id-numbers/audit-trail/`, {
          id_number: idNumber
        });
        setData(response.data);
      } catch (err: any) {
        setError(err.response?.data?.message || 'Failed to fetch audit trail');
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditTrail();
  }, [idNumber]);

  return { data, loading, error };
};